import useSWR from "swr";
import { Input, Label } from "reactstrap";
import { useTranslation } from "react-i18next";
import moment from "moment-timezone";
import Field from "../../../../../components/Field";
import Select from "../../../../../components/Inputs/Select";
import { useCompanyDateFormat } from "../../../../../utils/hooks/company";
import { renderSettingsResourceLabel } from "../../../../../utils/helpers/settings";

function Approve({ values }) {
    const { t } = useTranslation();
    const dateFormat = useCompanyDateFormat();

    const { data } = useSWR(() => {
        if (!values?.payGroup?.id) {
            return null;
        }
        return {
            url: `/pay-group/${values.payGroup.id}/items`,
            params: {
                startDate: moment(values?.endDate).format("YYYY-MM-DD"),
                pagination: "false",
            },
        };
    });

    return (
        <>
            <div className="d-flex flex-column mb-4">
                <Label>
                    {t("pay-group")}
                    <span className="text-danger mx-1">*</span>
                </Label>
                <Select disabled={true} value={values?.payGroup?.id}>
                    <Select.Option value={values?.payGroup?.id}>
                        {renderSettingsResourceLabel(values?.payGroup)}
                    </Select.Option>
                </Select>
            </div>

            <Field
                name="period"
                label={t("period")}
                rules={[
                    {
                        required: true,
                        message: t("period-required")
                    }
                ]}
            >
                <Select placeholder={t("period")}>
                    {data?.result
                        ?.filter((item) => item.status === "active")
                        ?.map((item) => (
                            <Select.Option value={item.id} key={item.id}>
                                {moment.parseZone(item.periodStartDate).format(dateFormat)}
                                {" - "}
                                {moment.parseZone(item.periodEndDate).format(dateFormat)}
                            </Select.Option>
                        ))}
                </Select>
            </Field>

            <Field name="reason">
                <Input
                    type="textarea"
                    resize="none"
                    placeholder={t("reason")}
                    rows={6}
                />
            </Field>
        </>
    );
}

export default Approve;
